export const ButtonInsert = (props) => {
    const { entity } = props;
    return (
        <div className="button-insert">
            <a className="button" href={`/admin/entity/insert/${entity}`} alt="insert">Insert</a>
        </div>
    )
}